enum PostedFrequencyType {
    Disbursement = "DISBURSEMENT",
    Repayment = "REPAYMENT"
}
export default PostedFrequencyType